const ModalFooter = ({
  onCancel,
  isLoading = null,
  onSave = null,
  showShadow = false,
}) => {
  return (
    <div
      className={`flex z-20 justify-end gap-4 pt-4 transition-shadow duration-200 ${
        showShadow ? 'shadow-[0_-4px_10px_rgba(0,0,0,0.15)]' : 'shadow-none'
      }`}
    >
      <button
        type="button"
        onClick={onCancel}
        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
      >
        Cancel
      </button>
      <button
        type="submit"
        className="py-2 px-6 bg-themeGradient text-white font-semibold rounded-md shadow-sm hover:bg-themeColor2"
        disabled={isLoading}
        onClick={onSave}
      >
        {isLoading ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};
export default ModalFooter;
